import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import { useHistory } from "react-router-dom";

export const DataTableGrid = (props) => {
  const [globalFilter, setGlobalFilter] = useState(null);
  const history = useHistory();

  const numberBodyTemplate = (rowData) => {
    return (
      <>
        <span className="p-column-title txt-bold">{rowData.secNumber}</span>
      </>
    );
  };

  // const trackBodyTemplate = (rowData) => {
  //     return (
  //         <>
  //             <span className="p-column-title txt-bold">{rowData.traId}</span>
  //         </>
  //     );
  // };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="actions">
        <Button
          icon="pi pi-pencil"
          className="p-mr-1"
          onClick={() => props.openDialog(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="btn-alert"
          onClick={() => props.openDeleteDialog(rowData)}
        />
      </div>
    );
  };

  const header = (
    <div className="table-header p-mb-5">
      <div className="p-m-0 p-col-1">
        <Button
          label="Back"
          icon="pi pi-chevron-left"
          onClick={() => history.goBack()}
          className="p-button-text btn-back txt-clrLight100"
        />
        <h1 className="p-m-0 fs-x-normal">Sectors</h1>
      </div>
      <div>
        <span className="p-input-icon-right p-mr-4">
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search Sector"
          />
        </span>
        <Button
          label="New Sector"
          icon="pi pi-plus"
          className="btn-primary"
          onClick={() => props.openDialog(props.emptyItem)}
        />
      </div>
    </div>
  );

  return (
    <DataTable
      value={props.items}
      dataKey="traId"
      paginator
      rows={10}
      rowsPerPageOptions={[5, 10, 25]}
      className="datatable-responsive table-layout-auto"
      globalFilter={globalFilter}
      emptyMessage="No Sectors found."
      header={header}
    >
      <Column
        field="secNumber"
        header="NUMBER"
        sortable
        body={numberBodyTemplate}
      />
      {/* <Column field="secNumber" header="TRACK" sortable body={trackBodyTemplate} /> */}
      <Column body={actionBodyTemplate} className="is-last" />
    </DataTable>
  );
};
